export default __webpack_public_path__ + "static/artisan-main-83cee4ac9ebbb0f3a6faab9a93a9c3bd.webp";